Ext.define('PagingToolbarExdNew', {
    extend: 'Ext.toolbar.Paging',
    alias: 'widget.pagingtoolbarexdnew',
    pagingStore: null,
    mobilePartTop: false,
    mobilePartBottom: false,
    cls: 'grid-toolbar-menu-new',
    grid: null,
    statics: {
        values: [10, 20, 30, 40, 50, 100, 200, 1000]
    },
    initComponent: function () {
        this.callParent(arguments);
        this.displayInfo = false;
        const me = this;
        let paginationMenu = Ext.create('Ext.menu.Menu', {
            itemId: 'paginationMenu',
            plain: true,
            items: [{
                text: Lang.kolumny,
                handler: function () {
                    paginationMenu.hide();
                    const btn = me.down('#tableViewBtn');
                    btn.showMenu();
                    columnsSubMenu.showBy(btn);
                }
            }, {
                text: Lang.liczba_wierszy_na_strone,
                handler: function () {
                    paginationMenu.hide();
                    const btn = me.down('#tableViewBtn');
                    btn.showMenu();
                    rowsSubMenu.showBy(btn);
                }
            }]
        });

        let columnsSubMenu = Ext.create('Ext.menu.Menu', {
            height: 400,
            itemId: 'columnsSubMenu',
            scrollable: false,
            plain: true,
            layout: {
                type: 'vbox',
                align: 'stretch'
            },
            items: [{
                    text: '< ' + Lang.powrot,
                    cls: 'menu-back-btn-text',
                    handler: function () {
                        columnsSubMenu.hide();
                        const btn = me.down('#tableViewBtn');
                        paginationMenu.showBy(btn);
                    }
                }, {
                    xtype: 'container',
                    itemId: 'columnsContainer',
                    flex: 1,
                    cls: 'menu-columns-submenu',
                    scrollable: 'y',
                    layout: 'vbox',
                    listeners: {
                        afterrender: function (cmp) {
                            const container = cmp;
                            const headerCt = me.grid.getView().getHeaderCt();
                            container.removeAll();
                            headerCt.getGridColumns().forEach(function (col) {
                                if (!col.isHideable) return;
                                container.add({
                                    xtype: 'checkbox',
                                    boxLabel: col.text,
                                    checked: !col.hidden,
                                    hideOnClick: false,
                                    handler: function (item) {
                                        col.setVisible(item.checked);
                                        me.rebuildFiltersMenu();
                                    }
                                });
                            });
                        }
                    }
                }, {
                    xtype: 'button',
                    text: Lang.domyslne_ustawienia,
                    cls: 'menu-default-settings-btn',
                    handler: function () {
                        columnsSubMenu.hide();
                        paginationMenu.showBy(me.down('#tableViewBtn'));
                        const stateId = me.grid.stateId;
                        if (stateId && Ext.state.Manager) {
                            Ext.state.Manager.clear(stateId);
                        }
                        const view = me.grid.getView();
                        const headerCt = view.getHeaderCt();
                        headerCt.items.each(function (col) {
                            if (col.isHideable) {
                                col.setVisible(!col.initialConfig.hidden);
                            }
                        });
                        view.refresh();

                        const columnsContainer = columnsSubMenu.down('#columnsContainer');
                        if (columnsContainer) {
                            columnsContainer.removeAll();

                            headerCt.getGridColumns().forEach(function (col) {
                                if (!col.isHideable) return;
                                columnsContainer.add({
                                    xtype: 'checkbox',
                                    boxLabel: col.text,
                                    checked: !col.hidden,
                                    hideOnClick: false,
                                    handler: function (item) {
                                        col.setVisible(item.checked);
                                    }
                                });
                            });
                        }
                        me.rebuildFiltersMenu();
                        paginationMenu.hide();
                    }
                }
            ]
        });

        let rowsSubMenu = Ext.create('Ext.menu.Menu', {
            itemId: 'rowsSubMenu',
            width: 200,
            bodyCls: 'menu-rows-submenu',
            plain: true,
            items: [{
                text: '< ' + Lang.powrot,
                cls: 'menu-back-btn-text',
                handler: function () {
                    rowsSubMenu.hide();
                    const btn = me.down('#tableViewBtn');
                    paginationMenu.showBy(btn);
                }
            }, {
                xtype: 'labelexd',
                text: Lang.liczba_wierszy_na_strone,
                cls: 'menu-label-text'
            }, {
                xtype: 'comboexd',
                store: PagingToolbarExd.values,
                cls: 'menu-number-of-rows-per-page-combo',
                listeners: {
                    scope: me,
                    select: this.onComboBoxSelect
                }
            }]
        });

        var tableViewBtn = {
            xtype: 'button',
            itemId: 'tableViewBtn',
            ui: 'btn-terciary-s',
            cls: 'custom-menu-btn',
            iconCls: 'iconMenuCols',
            text: Lang.table_view,
            menu: paginationMenu
        };

        this.filtersMenu = Ext.create('Ext.panel.Panel', {
            floating: true,
            shadow: true,
            frame: false,
            scrollable: 'y',
            height: 300,
            defaults: {
                width: 260,
                labelWidth: 290,
                labelAlign: 'top',
                margin: '5 10 5 10',
            },
            width: 300,
            bodyPadding: 0,
            items: []
        });

        this.fastSearch = {
            xtype: 'textfieldexd',
            itemId: 'fastSearch',
            flex: 1,
            maxWidth: 200,
            emptyText: Lang.fast_search,
            stateful: false,
            listeners: {
                change: function (field, value) {
                    let store = me.grid.getStore();
                    const filters = store.getFilters();
                    const filterId = 'fastSearch';
                    filters.removeAtKey(filterId);
                    if (value !== null && value !== undefined && value !== '') {
                        let in_ = []
                        const gridColumns = me.grid.getView().getHeaderCt().getGridColumns();
                        gridColumns.forEach(function (column) {
                            if (column.filterable && column.filter && !column.hidden && column.filter.type !== 'boolean' && column.filter.type !== 'date') {
                                in_.push(column.dataIndex);
                            }
                        });
                        let isMemoryProxy = me.isMemoryProxy(store.getProxy());
                        if (isMemoryProxy) {
                            store.addFilter({
                                id: filterId,
                                property_fastSearch: filterId,
                                filterFn: function(record) {
                                    const data = record.getData();
                                    return in_.some(fieldName => {
                                        const val = data[fieldName];
                                        return val != null && String(val).toLowerCase().includes(value.toLowerCase());
                                    });
                                },
                            });
                        } else {
                            filters.add(new Ext.util.Filter({
                                id: filterId,
                                property_fastSearch: filterId,
                                in_fastSearch: in_,
                                value_fastSearch: value
                            }));
                        }
                    }
                }
            }
        }

        this.filtersBtn = {
            itemId: 'filtersBtn',
            xtype: 'button',
            ui: 'btn-secondary-s',
            cls: 'custom-menu-btn',
            iconCls: 'iconFilters',
            text: Lang.rozszerzone_filtrowanie,
            handler: function(btn) {
                const panel = me.filtersMenu;
                if (panel.isVisible()) {
                    panel.hide();
                } else {
                    panel.showBy(btn, 'tl-bl?');
                    Ext.getBody().on('mousedown', me.onOutsideClick, this);
                }
            },
            scope: this
        };

        me.grid.on('afterrender', function () {
            me.rebuildFiltersMenu();
        });

        me.grid.getStore().on('filterchange', function () {
            if (me.filtersMenu && !me.filtersMenu.isVisible()) {
                let isMemoryProxy = me.isMemoryProxy(me.grid.getStore().getProxy());
                if (isMemoryProxy) {
                    me.rebuildFiltersMenu();
                }
            }
        });

        me.grid.getStore().on('load', function () {
            if (me.filtersMenu && !me.filtersMenu.isVisible()) {
                me.rebuildFiltersMenu();
            }
        });

        if (Ext.os.is.Phone && (Config.mobileuidisabled != 1)) {
            if (this.mobilePartTop) {
                this.insert(0, this.fastSearch);
                this.insert(1, this.filtersBtn);
                this.insert(2, tableViewBtn);
                this.comboBox = rowsSubMenu.down('comboexd');
                const items = this.items;
                const count = items.length;
                for (let i = count - 1; i >= 3; i--) {
                    this.remove(items.getAt(i));
                }
            } else if (this.mobilePartBottom) {
                const items = this.items;
                const count = items.length;
                for (let i = count - 1; i >= 9; i--) {
                    this.remove(items.getAt(i));
                }
            }
        } else {
            this.insert(0, this.fastSearch);
            this.insert(1, this.filtersBtn);
            this.insert(2, '->');
            this.remove(13);
            this.remove(12);
            this.add(tableViewBtn);
            this.comboBox = rowsSubMenu.down('comboexd');
        }
    },
    onComboBoxSelect: function (combobox, record) {
        this.pagingStore.setPageSize(record.get("field1"));
        this.pagingStore.load();
    },
    updatePageSize: function (newPageSize) {
        this.comboBox.setValue(newPageSize);
        this.pagingStore.setPageSize(newPageSize);
    },
    onOutsideClick: function (e) {
        const panel = this.filtersMenu;
        const btnCmp = Ext.ComponentQuery.query('#filtersBtn')[0];
        const btnEl = btnCmp && btnCmp.getEl();
        const clickedEl = e.target;

        if (panel.getEl().contains(clickedEl) || (btnEl && btnEl.contains(clickedEl))) {
            return;
        }

        const selectors = ['.x-layer', '.x-picker', '.x-boundlist', '.x-datepicker', '.x-menu', '.x-window'];
        let isInsideFloatingEl = false;

        selectors.forEach(selector => {
            const nodes = document.querySelectorAll(selector);
            nodes.forEach(node => {
                if (node.contains(clickedEl)) {
                    isInsideFloatingEl = true;
                }
            });
        });
        if (isInsideFloatingEl) {
            return;
        }
        panel.hide();
    },
    createFilterContainer: function (column) {
        const me = this;
        let filter = column.filter;
        let filterId = column.dataIndex;
        if (filter.type === 'numeric') {
            let isExpanded = false;
            const numberContainer = Ext.create('Ext.form.FieldContainer', {
                fieldLabel: column.text,
                layout: 'vbox',
                margin: '5 10 5 10',
                flex: 1,
                defaults: {
                    width: 250,
                    labelWidth: 20,
                    margin: '5 5 5 5'
                },
                labelAlign: 'top',
                items: [{
                    xtype: 'textfieldexd',
                    readOnly: true,
                    editable: false,
                    defaults: {
                        margin: '5 10 5 10',
                    },
                    itemId: 'summaryField' + '_' + filterId,
                    value: Lang.filters,
                    listeners: {
                        render: function (cmp) {
                            cmp.getEl().on('click', function () {
                                toggleFilterFields();
                            });
                        }
                    }
                }, {
                    xtype: 'numberfieldexd',
                    itemId: 'equalField' + '_' + filterId,
                    fieldLabel: '=',
                    hidden: true,
                    listeners: {
                        change: function (field, value) {
                            updateFilter(column.dataIndex,'eq', value);
                        }
                    }
                }, {
                    xtype: 'numberfieldexd',
                    itemId: 'greaterField' + '_' + filterId,
                    fieldLabel: '>',
                    hidden: true,
                    listeners: {
                        change: function (field, value) {
                            updateFilter(column.dataIndex,'gt', value);
                        }
                    }
                }, {
                    xtype: 'numberfieldexd',
                    itemId: 'lessField' + '_' + filterId,
                    fieldLabel: '<',
                    hidden: true,
                    listeners: {
                        change: function (field, value) {
                            updateFilter(column.dataIndex,'lt', value);
                        }
                    }
                }],
                collapseFields: function () {
                    isExpanded = false;
                    this.down('#equalField' + '_' + filterId).hide();
                    this.down('#greaterField' + '_' + filterId).hide();
                    this.down('#lessField' + '_' + filterId).hide();
                }
            });
            updateSummaryText(filterId);
            me.filterContainers.push(numberContainer);
            me.filtersMenu.add(numberContainer);
            function toggleFilterFields() {
                isExpanded = !isExpanded;
                numberContainer.down('#equalField' + '_' + filterId).setVisible(isExpanded);
                numberContainer.down('#greaterField' + '_' + filterId).setVisible(isExpanded);
                numberContainer.down('#lessField' + '_' + filterId).setVisible(isExpanded);
            }
            function updateFilter(name, operator, value) {
                const store = me.grid.getStore();
                const filters = store.getFilters();
                let isMemoryProxy = me.isMemoryProxy(store.getProxy());
                const filterId = column.dataIndex + '-' + operator;
                filters.removeAtKey(filterId);
                if (value !== null && value !== undefined && value !== '') {
                    if (isMemoryProxy) {
                        filters.add(new Ext.util.Filter({
                            id: filterId,
                            property: column.dataIndex,
                            operator: operator,
                            filterFn: function(record) {
                                const val = record.get(column.dataIndex);
                                if (val == null) return false;
                                if (operator === 'lt') {
                                    return val < value;
                                } else if (operator === 'gt') {
                                    return val > value;
                                } else if (operator === 'eq') {
                                    return val === value;
                                }
                                return false;
                            },
                            value: value
                        }));
                    } else {
                        filters.add(new Ext.util.Filter({
                            id: filterId,
                            property: column.dataIndex,
                            operator: operator,
                            value: value
                        }));
                    }
                }
                updateSummaryText(name);
                if (!isMemoryProxy) {
                    store.load();
                }
            }
            function updateSummaryText(name) {
                const store = me.grid.getStore();
                const filters = store.getFilters();
                let summary = filters
                    .getRange()
                    .filter(filter => {
                        const id = filter.config?.id;
                        return id && new RegExp('^' + name + '-(eq|lt|gt)$').test(id);
                    })
                    .map(filter => {
                        let val = filter.getValue();
                        const operator = filter.getOperator ? filter.getOperator() : null;

                        const fieldMap = {
                            lt: numberContainer.down('#lessField' + '_' + filterId),
                            gt: numberContainer.down('#greaterField' + '_' + filterId),
                            eq: numberContainer.down('#equalField' + '_' + filterId)
                        };

                        const field = fieldMap[operator];
                        if (field) {
                            field.suspendEvents();
                            field.setValue(val);
                            field.resumeEvents();
                        }

                        if (operator === 'lt') {
                            val = '<' + val;
                        } else if (operator === 'gt') {
                            val = '>' + val;
                        } else if (operator === 'eq') {
                            val = '=' + val;
                        }
                        return val;
                    })
                    .join(', ') || Lang.filters;

                const summaryField = numberContainer.down('#summaryField' + '_' + filterId);
                summaryField.setValue(summary);
            }
        } else if (filter.type === 'string') {
            const store = me.grid.getStore();
            const filters = store.getFilters();
            const filterId = column.dataIndex;
            const activeFilter = filters.get(filterId);
            const initialValue = activeFilter ? activeFilter.getValue() : filter.getValue ? filter.getValue() : filter.value;
            const stringContainer = Ext.create('Ext.form.FieldContainer', {
                fieldLabel: column.text,
                layout: 'vbox',
                margin: '5 10 5 10',
                flex: 1,
                defaults: {
                    width: 250,
                    labelWidth: 20,
                    margin: '5 5 5 5'
                },
                labelAlign: 'top',
                items: [{
                    xtype: 'textfieldexd',
                    itemId: 'stringField' + '_' + filterId,
                    labelAlign: 'top',
                    emptyText: Lang.filters,
                    readOnly: false,
                    editable: true,
                    defaults: {
                        margin: '5 10 5 10',
                    },
                    value: initialValue,
                    listeners: {
                        change: function (field, value) {
                            updateFilter('like', value);
                        },
                    }
                }]
            });
            me.filtersMenu.add(stringContainer);
            function updateFilter(operator, value) {
                const store = me.grid.getStore();
                const filters = store.getFilters();
                const filterId = column.dataIndex + '-' + operator;
                filters.removeAtKey(filterId);
                let isMemoryProxy = me.isMemoryProxy(store.getProxy());
                if (value !== null && value !== undefined && value !== '') {
                    if (isMemoryProxy) {
                        filters.add(new Ext.util.Filter({
                            id: filterId,
                            filterFn: function(record) {
                                const val = record.get(column.dataIndex);
                                if (val == null) return false;
                                return String(val).toLowerCase().includes(String(value).toLowerCase());
                            },
                            property: column.dataIndex,
                            operator: operator,
                            value: value
                        }));
                    } else {
                        filters.add(new Ext.util.Filter({
                            id: filterId,
                            property: column.dataIndex,
                            operator: operator,
                            value: value
                        }));
                    }
                }
                if (!isMemoryProxy) {
                    store.load();
                }
                updateSummaryText();
            }
            function updateSummaryText(withoutUpdate) {
                const store = me.grid.getStore();
                const filters = store.getFilters();
                let summary = filters
                    .getRange()
                    .filter(filter => {
                        let boolNotNull = filter.config.id !== null && filter.config.id !== undefined;
                        let boolFilter = new RegExp('^' + filterId + '-(like)$').test(filter.config.id);
                        return boolNotNull && boolFilter;
                    })
                    .map(filter => filter.getValue());

                const newValue = summary.join(', ');
                const textField = stringContainer.down('#stringField' + '_' + filterId);
                const oldValue = textField.getValue();
                if (oldValue !== newValue) {
                    if (withoutUpdate) {
                        textField.suspendEvents(false);
                    }
                    textField.setValue(newValue);
                    if (withoutUpdate) {
                        textField.resumeEvents();
                    }
                }
            }
            updateSummaryText(true);
        } else if (filter.type === 'boolean') {
            // const initialValue = (filter.getValue ? filter.getValue() : filter.value);
            const filterId = column.dataIndex;
            let isExpanded = false;

            const booleanContainer = Ext.create('Ext.form.FieldContainer', {
                fieldLabel: column.text,
                layout: 'vbox',
                margin: '5 10 5 10',
                flex: 1,
                defaults: {
                    width: 250,
                    labelWidth: 20,
                    margin: '5 5 5 5'
                },
                labelAlign: 'top',
                items: [{
                    xtype: 'textfieldexd',
                    readOnly: true,
                    editable: false,
                    itemId: 'summaryField_' + filterId,
                    value: Lang.filters,
                    listeners: {
                        render: function (cmp) {
                            cmp.getEl().on('click', function () {
                                toggleFilterFields();
                            });
                        }
                    }
                }, {
                    xtype: 'radiogroup',
                    itemId: 'booleanField_' + filterId,
                    hidden: true,
                    columns: 1,
                    vertical: true,
                    items: [
                        { boxLabel: Lang.tak, inputValue: true, name: 'bool_' + filterId },
                        { boxLabel: Lang.nie, inputValue: false, name: 'bool_' + filterId }
                    ],
                    // value: { ['bool_' + filterId]: initialValue },
                    listeners: {
                        change: function (field, newValue) {
                            updateFilter('eq', newValue['bool_' + filterId]);
                        }
                    }
                }],
                collapseFields: function () {
                    isExpanded = false;
                    this.down('#booleanField_' + filterId).hide();
                }
            });

            me.filterContainers.push(booleanContainer);
            me.filtersMenu.add(booleanContainer);

            function toggleFilterFields() {
                isExpanded = !isExpanded;
                booleanContainer.down('#booleanField_' + filterId).setVisible(isExpanded);
            }

            function updateFilter(operator, value) {
                const store = me.grid.getStore();
                const filters = store.getFilters();
                const fullFilterId = column.dataIndex + '-' + operator;

                filters.removeAtKey(fullFilterId);
                let isMemoryProxy = me.isMemoryProxy(store.getProxy());

                if (value !== null && value !== undefined) {
                    if (isMemoryProxy) {
                        filters.add(new Ext.util.Filter({
                            id: fullFilterId,
                            filterFn: function (record) {
                                return record.get(column.dataIndex) === value;
                            },
                            property: column.dataIndex,
                            operator: operator,
                            value: value
                        }));
                    } else {
                        filters.add(new Ext.util.Filter({
                            id: fullFilterId,
                            property: column.dataIndex,
                            operator: operator,
                            value: value
                        }));
                    }
                }

                if (!isMemoryProxy) {
                    store.load();
                }

                updateSummaryText();
            }

            function updateSummaryText(withoutUpdate) {
                const store = me.grid.getStore();
                const filters = store.getFilters();
                let summary = filters
                    .getRange()
                    .find(filter => {
                        let boolNotNull = filter.config.id !== null && filter.config.id !== undefined;
                        let boolFilter = new RegExp('^' + filterId + '-eq$').test(filter.config.id);
                        return boolNotNull && boolFilter;
                    })?.getValue();

                const boolField = booleanContainer.down('#booleanField_' + filterId);
                if (!boolField) return;
                const val = summary;

                const summaryValue = val === true ? 'Tak' :
                    val === false ? 'Nie' :
                        Lang.filters;

                const summaryField = booleanContainer.down('#summaryField_' + filterId);
                if (summaryField && summaryField.getValue() !== summaryValue) {
                    summaryField.setValue(summaryValue);
                }
            }
            updateSummaryText(true);
        } else if (filter.type === 'date') {
            let isExpanded = false;
            const dateContainer = Ext.create('Ext.form.FieldContainer', {
                fieldLabel: column.text,
                layout: 'vbox',
                margin: '5 10 5 10',
                flex: 1,
                defaults: {
                    width: 250,
                    labelWidth: 50,
                    margin: '5 5 5 5'
                },
                labelAlign: 'top',
                items: [{
                    xtype: 'textfieldexd',
                    readOnly: true,
                    editable: false,
                    itemId: 'summaryField_' + filterId,
                    value: Lang.filters,
                    listeners: {
                        render: function (cmp) {
                            cmp.getEl().on('click', function () {
                                toggleDateFields();
                            });
                        }
                    }
                }, {
                    xtype: 'datefieldexd',
                    fieldLabel: Lang.przed,
                    itemId: 'dateBefore_' + filterId,
                    format: 'Y-m-d',
                    hidden: true,
                    listeners: {
                        scope: this,
                        change: function () {
                            applyDateFilters();
                        }
                    }
                }, {
                    xtype: 'datefieldexd',
                    fieldLabel: Lang.po,
                    itemId: 'dateAfter_' + filterId,
                    format: 'Y-m-d',
                    hidden: true,
                    listeners: {
                        scope: this,
                        change: function () {
                            applyDateFilters();
                        }
                    }
                }, {
                    xtype: 'datefieldexd',
                    fieldLabel: Lang.ww,
                    itemId: 'dateEqual_' + filterId,
                    format: 'Y-m-d',
                    hidden: true,
                    listeners: {
                        scope: this,
                        change: function () {
                            applyDateFilters();
                        }
                    }
                }],
                collapseFields: function () {
                    ['dateBefore_', 'dateAfter_', 'dateEqual_'].forEach(id => {
                        this.down('#' + id + filterId).hide();
                    });
                }
            });

            me.filterContainers.push(dateContainer);
            me.filtersMenu.add(dateContainer);
            updateDateSummaryText(filterId);

            function toggleDateFields() {
                isExpanded = !isExpanded;
                dateContainer.down('#dateEqual_' + filterId).setVisible(isExpanded);
                dateContainer.down('#dateAfter_' + filterId).setVisible(isExpanded);
                dateContainer.down('#dateBefore_' + filterId).setVisible(isExpanded);
            }

            function applyDateFilters() {
                const store = me.grid.getStore();
                const filters = store.getFilters();
                const field = column.dataIndex;
                let isMemoryProxy = me.isMemoryProxy(store.getProxy());
                ['lt', 'gt', 'eq'].forEach(op => filters.removeAtKey(field + '-' + op));
                const before = dateContainer.down('#dateBefore_' + filterId).getValue2();
                const after = dateContainer.down('#dateAfter_' + filterId).getValue2();
                const equal = dateContainer.down('#dateEqual_' + filterId).getValue2();
                if (before) {
                    if (isMemoryProxy) {
                        filters.add({
                            id: field + '-lt',
                            property: field,
                            operator: 'lt',
                            filterFn: function (record) {
                                const val = record.get(field);
                                return val && val < before;
                            },
                            value: before
                        });
                    } else {
                        filters.add({
                            id: field + '-lt',
                            property: field,
                            operator: 'lt',
                            value: before
                        });
                    }
                }
                if (after) {
                    if (isMemoryProxy) {
                        filters.add({
                            id: field + '-gt',
                            property: field,
                            operator: 'gt',
                            filterFn: function (record) {
                                const val = record.get(field);
                                return val && val > after;
                            },
                            value: after
                        });
                    } else {
                        filters.add({
                            id: field + '-gt',
                            property: field,
                            operator: 'gt',
                            value: after
                        });
                    }
                }
                if (equal) {
                    if (isMemoryProxy) {
                        filters.add({
                            id: field + '-eq',
                            property: field,
                            operator: 'eq',
                            filterFn: function (record) {
                                const val = record.get(field);
                                return val && Ext.Date.isEqual(val, equal);
                            },
                            value: equal
                        });
                    } else {
                        filters.add({
                            id: field + '-eq',
                            property: field,
                            operator: 'eq',
                            value: equal
                        });
                    }
                }
                updateDateSummaryText(filterId);
                if (!isMemoryProxy) {
                    store.load();
                }
            }

            function updateDateSummaryText(name) {
                const store = me.grid.getStore();
                const filters = store.getFilters();
                const summaryField = dateContainer.down('#summaryField_' + name);
                const fieldMap = {
                    lt: dateContainer.down('#dateBefore_' + name),
                    gt: dateContainer.down('#dateAfter_' + name),
                    eq: dateContainer.down('#dateEqual_' + name)
                };

                let beforeText = '', afterText = '', equalText = '';

                filters.getRange().forEach(filter => {
                    const id = filter.config?.id;
                    if (id && new RegExp('^' + name + '-(eq|lt|gt)$').test(id)) {
                        const operator = filter.getOperator ? filter.getOperator() : null;
                        let val = filter.getValue();

                        if (val && typeof val === 'string' && val.includes(' ')) {
                            val = val.split(' ')[0];
                        }

                        const field = fieldMap[operator];
                        if (field) {
                            field.suspendEvents();
                            field.setValue(val);
                            field.resumeEvents();
                        }

                        if (operator === 'lt') {
                            beforeText = '< ' + val;
                        } else if (operator === 'gt') {
                            afterText = '> ' + val;
                        } else if (operator === 'eq') {
                            equalText = '= ' + val;
                        }
                    }
                });

                const parts = [];
                if (beforeText) parts.push(beforeText);
                if (afterText) parts.push(afterText);
                if (equalText) parts.push(equalText);
                summaryField.setValue(parts.length ? parts.join(', ') : Lang.filters);
            }
        } else if (filter.type === 'list') {
            const options = filter.options || null;
            const fstore = filter.store || null;
            const idField = filter.idField || 'id';
            const labelField = filter.labelField || 'imie';
            const listContainer = Ext.create('Ext.form.FieldContainer', {
                fieldLabel: column.text,
                layout: 'vbox',
                margin: '5 10 5 10',
                flex: 1,
                defaults: {
                    width: 250,
                    labelWidth: 20,
                    margin: '5 5 5 5'
                },
                labelAlign: 'top',
                items: [{
                    xtype: 'textfieldexd',
                    readOnly: true,
                    editable: false,
                    itemId: 'summaryField_' + filterId,
                    value: Lang.filters,
                    listeners: {
                        render: function (cmp) {
                            cmp.getEl().on('click', function () {
                                toggleListFields();
                            });
                        }
                    }
                }, {
                    xtype: 'checkboxgroup',
                    itemId: 'checkboxGroup_' + filterId,
                    columns: 1,
                    hidden: true,
                    listeners: {
                        change: function (group, newValue) {
                            const selectedValues = Object.values(newValue)[0];
                            applyListFilter(column.dataIndex, selectedValues);
                        }
                    }
                }],
                collapseFields: function () {
                    this.down('#checkboxGroup_' + filterId).hide();
                }
            });

            me.filterContainers.push(listContainer);
            me.filtersMenu.add(listContainer);
            const group = listContainer.down('#checkboxGroup_' + filterId);

            if (fstore) {
                const clonedStore = Ext.create('Ext.data.Store', Ext.apply({}, fstore.initialConfig));
                filter.store = clonedStore;
                clonedStore.load({
                    callback: function (records) {
                        const items = records.map(record => ({
                            boxLabel: record.get(labelField),
                            inputValue: record.get(idField),
                            name: 'list_' + filterId
                        }));
                        if (group && !group.destroyed && group.add) {
                            group.add(items);
                            updateListSummaryText(column.dataIndex);
                        }
                    }
                });
            } else if (Array.isArray(options)) {
                const items = options.map(opt => {
                    if (typeof opt === 'string') {
                        return {
                            boxLabel: opt,
                            inputValue: opt,
                            name: 'list_' + filterId
                        };
                    } else if (Array.isArray(opt)) {
                        return {
                            boxLabel: opt[1],
                            inputValue: opt[0],
                            name: 'list_' + filterId
                        };
                    }
                });
                if (group && !group.destroyed && group.add) {
                    group.add(items);
                    updateListSummaryText(column.dataIndex);
                }
                updateListSummaryText(column.dataIndex);
            }

            function toggleListFields() {
                const group = listContainer.down('#checkboxGroup_' + filterId);
                group.setVisible(!group.isVisible());
            }

            function applyListFilter(field, selectedValues) {
                const store = me.grid.getStore();
                let isMemoryProxy = me.isMemoryProxy(store.getProxy());
                const filters = store.getFilters();
                const filterIdFull = field + '-in';

                const existing = filters.get(filterIdFull);
                const existingVal = existing ? existing.getValue() : [];

                const toArray = val => Array.isArray(val) ? val : (val ? [val] : []);
                const oldArr = toArray(existingVal).sort();
                const newArr = toArray(selectedValues).sort();

                if (JSON.stringify(oldArr) === JSON.stringify(newArr)) {
                    return;
                }

                filters.removeAtKey(filterIdFull);

                const normalized = Array.isArray(selectedValues)
                    ? selectedValues
                    : selectedValues != null && selectedValues !== ''
                        ? [selectedValues]
                        : [];

                if (normalized.length > 0) {
                    if (isMemoryProxy) {
                        filters.add(new Ext.util.Filter({
                            id: filterIdFull,
                            property: field,
                            operator: 'in',
                            value: normalized,
                            filterFn: function (record) {
                                const val = record.get(field);
                                return normalized.includes(val);
                            }
                        }));
                    } else {
                        filters.add(new Ext.util.Filter({
                            id: filterIdFull,
                            property: field,
                            operator: 'in',
                            value: normalized
                        }));
                    }
                }

                updateListSummaryText(field);
                if (!isMemoryProxy) {
                    store.load();
                }
            }

            function updateListSummaryText(field) {
                const store = me.grid.getStore();
                const filters = store.getFilters();
                const currentFilter = filters.get(field + '-in');
                const summaryField = listContainer.down('#summaryField_' + filterId);
                const checkboxGroup = listContainer.down('#checkboxGroup_' + filterId);
                let selected = currentFilter ? currentFilter.getValue() : [];
                if (!Array.isArray(selected)) {
                    selected = selected ? [selected] : [];
                }
                if (selected.length > 0) {
                    const labels = [];

                    if (filter.store) {
                        filter.store.each(record => {
                            if (selected.includes(record.get(idField))) {
                                labels.push(record.get(labelField));
                            }
                        });
                    } else if (Array.isArray(options)) {
                        options.forEach(opt => {
                            const val = typeof opt === 'string' ? opt : opt[0];
                            const label = typeof opt === 'string' ? opt : opt[1];
                            if (selected.includes(val)) {
                                labels.push(label);
                            }
                        });
                    }

                    summaryField.setValue(labels.join(', '));
                    checkboxGroup.setValue({ ['list_' + filterId]: selected });
                } else {
                    summaryField.setValue(Lang.filters);
                    checkboxGroup.reset();
                }
            }
        }
    },
    isMemoryProxy: function (proxy) {
        return proxy &&
            (proxy.alias?.includes('proxy.memory') ||
                proxy.isMemoryProxy ||
                proxy.$className === 'Ext.data.proxy.Memory' ||
                (proxy.btype && proxy.btype === "inmemory")
            );
    },
    rebuildFiltersMenu: function () {
        const me = this;
        let filtersMenu = me.filtersMenu;
        const gridColumns = me.grid.getView().getHeaderCt().getGridColumns();
        me.filterContainers = [];
        filtersMenu.removeAll();
        gridColumns.forEach(function (column) {
            if (column.filterable && column.filter && !column.hidden) {
                me.createFilterContainer(column);
            }
        });
        filtersMenu.on('hide', function () {
            me.filterContainers.forEach(function (container) {
                if (typeof container.collapseFields === 'function') {
                    container.collapseFields();
                }
            });
        });
    },
    getPagingItems: function () {
        var me = this;
        var inputListeners = {
            scope: me,
            blur: me.onPagingBlur
        };
        return [{
            itemId: 'displayItem',
            tooltip: me.displayMsg,
            overflowText: me.displayMsg,
            hidden: true,
            scope: me,
        }, {
            itemId: 'first',
            tooltip: me.firstText,
            overflowText: me.firstText,
            ui: 'btn-terciary-s',
            iconCls: Ext.baseCSSPrefix + 'tbar-page-first',
            disabled: true,
            handler: me.moveFirst,
            scope: me
        }, {
            itemId: 'prev',
            tooltip: me.prevText,
            overflowText: me.prevText,
            ui: 'btn-terciary-s',
            iconCls: Ext.baseCSSPrefix + 'tbar-page-prev',
            disabled: true,
            handler: me.movePrevious,
            scope: me
        }, '-', me.beforePageText, {
            xtype: 'numberfield',
            itemId: 'inputItem',
            name: 'inputItem',
            cls: Ext.baseCSSPrefix + 'tbar-page-number',
            allowDecimals: false,
            minValue: 1,
            hideTrigger: true,
            enableKeyEvents: true,
            keyNavEnabled: false,
            selectOnFocus: true,
            submitValue: false,
            isFormField: false,
            width: me.inputItemWidth,
            margin: '0 7 0 0',
            listeners: inputListeners
        }, {
            xtype: 'tbtext',
            itemId: 'afterTextItem',
            html: Ext.String.format(me.afterPageText, 1)
        }, '-', {
            itemId: 'next',
            tooltip: me.nextText,
            overflowText: me.nextText,
            iconCls: Ext.baseCSSPrefix + 'tbar-page-next',
            disabled: true,
            ui: 'btn-terciary-s',
            handler: me.moveNext,
            scope: me
        }, {
            itemId: 'last',
            tooltip: me.lastText,
            overflowText: me.lastText,
            ui: 'btn-terciary-s',
            iconCls: Ext.baseCSSPrefix + 'tbar-page-last',
            disabled: true,
            margin: '0 30 0 0',
            handler: me.moveLast,
            scope: me
        }];
    }
});